import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateFormField } from "./Slices/formSlice";
import { toastMsg } from "../component/toast";
import CustomButton from "../component/button";
import KeywordSkeleton from "../component/skeletons/keywordSkeleton";
import InputSkeleton from "../component/skeletons/InputSkeleton";
import { Spinner } from "react-bootstrap";


export default function SubTopics() {

  const [newSubTopics, setNewSubTopics] = useState(['', '', '', '', ''])
  const navigate = useNavigate();
  const formData = useSelector((state) => state.form);
  const [isLoading, setIsLoading] = useState(false)

  const [customTopicName, setCustomTopicName] = useState({})
  const [subTopicsAll, setSubTopics] = useState([])
  const state = useSelector(state => state.form)

  const dispatch = useDispatch()

  const getSelectedSubTopics = () => {




    if (state.topics?.length > 0) {

      let sortTopic = state?.topics?.slice()?.sort((a, b) => a.localeCompare(b));
      let sortPrevTopic = state?.customTopics?.previousSubTopics?.slice()?.sort((a, b) => a.localeCompare(b));

      if (sortTopic.toString() == sortPrevTopic?.toString()) {

        setSubTopics(state?.allSubTopics)

        return

      }

    }


    setIsLoading(true)
    // dispatch(updateFormField({ field: "subTopics", value: [] }))


    PostCallWithErrorResponse(ApiConfig.GET_CUSTOM_SUB_TOPICS, {
      "job_description": state?.finalSelectedJobDescription,
      "topics": state.topics
    }).then((res) => {


      console.log(res?.json);

      if (res?.json?.status == 200) {
        let topicsMrg = {
          recomented: [],
          nonRecomennted: []
        }

        let topicsName = []

        let temp = res?.json?.custom_subtopics?.subtopics

        temp?.forEach((i, index) => {

          topicsName.push(i?.topic)

          topicsMrg.recomented = [...topicsMrg.recomented, ...i?.recommended_subtopics]
          topicsMrg.nonRecomennted = [...topicsMrg.nonRecomennted, ...i?.unrecommended_subtopics]



        })

        dispatch(updateFormField({ field: "subTopics", value: [...topicsMrg.recomented?.slice(0, topicsMrg.recomented?.length > 6 ? 6 : topicsMrg.recomented.length)] }))

        console.log(topicsMrg)

        dispatch(updateFormField({
          field: 'customTopics', value: {
            ...state.customTopics,
            previousSubTopics: topicsName
          }
        }))
        dispatch(updateFormField({ field: "allSubTopics", value: res?.json?.custom_subtopics?.subtopics }))
        setSubTopics(res?.json?.custom_subtopics?.subtopics)
        setIsLoading(false)
      }



    })

  }

  useEffect(() => {
    getSelectedSubTopics()
  }, [])


  const maxSelection = 12;

  const [sections, setSections] = useState([
    {
      title: "Project Management",
      recommendedtitle: "Recommended",
      recommended: [
        "Project Planning",
        "Risk Management",
        "Stakeholder Communication",
        "Scope Management",
        "Change Management",
        "Project Reporting",
        "Project Closure",
      ],
      nonRecommended: [
        "Milestone Tracking",
        "Agile Methodologies",
        "Project Quality Management",
        "Resource Allocation",
        "Budget Management",
        "Project Scheduling",
        "Project Tracking",
        "Project Documentation",
        "Time Management",
        "Task Delegation",
        "Project Governance",
        "Waterfall Methodologies",
        "Project Integration Management",
      ],
      customInput: "",
    },
    {
      title: "Recommendation",
      topics: [
        "Mentorship Programs",
        "Continuous Learning",
        "Cross-functional Teams",
        "Leadership Development",
        "Automation Tools",
        "Peer Reviews",
        "Knowledge Sharing",
        "Retrospective Meetings",
        "Risk Mitigation Strategies",
        "Client Feedback Loops",
      ],
      customInput: "",
    },
    {
      title: "Not Recommendation",
      topics: [
        "Micromanagement",
        "Overengineering",
        "Unrealistic Deadlines",
        "Ignoring Stakeholder Input",
        "Lack of Documentation",
        "Single Point of Failure",
        "Skipping QA",
        "Siloed Teams",
        "No Feedback Mechanism",
        "Reactive Planning",
      ],
      customInput: "",
    },
  ]);

  const [selectedItems, setSelectedItems] = useState([]);



  const handleChange = (subTopic) => {

    if (state?.subTopics?.includes(subTopic)) {

      dispatch(updateFormField({ field: 'subTopics', value: state.subTopics?.filter((i) => i != subTopic) }))

    } else {
      dispatch(updateFormField({ field: 'subTopics', value: [...state.subTopics, subTopic] }))
    }

  }



  const handleAddCustomTopic = (sectionIndex) => {
    const newTopic = sections[sectionIndex].customInput.trim();
    if (!newTopic) return;



    const updatedSections = [...sections];
    if (!updatedSections[sectionIndex].topics.includes(newTopic)) {
      updatedSections[sectionIndex].topics.push(newTopic);
    }
    updatedSections[sectionIndex].customInput = "";
    setSections(updatedSections);
  };


  console.log(state);

  const handleNext = () => {
    if (state.subTopics?.length > 0) {
      navigate('/assessmentGenerator')
    } else {
      toastMsg('error', 'please Select Sub Topics')
    }

  }



  const addCutomTopic = (index) => {



    if (!newSubTopics[index]) return



    let isIn = state?.allSubTopics[index]?.recommended_subtopics?.findIndex((i) => i?.trim()?.toLowerCase() == newSubTopics[index]?.toLowerCase()?.trim())

    if (isIn != -1) {
      toastMsg('error', 'Already  Added')
      return
    }

    if (state.subTopics?.length < maxSelection) {
      dispatch(updateFormField({ field: 'subTopics', value: [...state?.subTopics, newSubTopics[index].trim()] }))
    }

    let tp = [...newSubTopics]

    tp[index] = ''

    setNewSubTopics(tp)


    let newSub = state?.allSubTopics?.map((i, indx) => {
      if (indx === index) {
        return {
          ...i,
          recommended_subtopics: [newSubTopics[index]?.trim(), ...i.recommended_subtopics]
        }
      }
      return i
    })


    dispatch(updateFormField({ field: 'allSubTopics', value: newSub }))




  }

  return (
    <div
      style={{ backgroundColor: '#F2F4F7' }}
      className={`canLisContentWrap `}

    >
      <div className="t-wrapper-div p-4">
        <div className=" mb-1">
          <h5 className="ja-1 mainTitleColr ">SubTopics Extracted from Topics:</h5>
          <p className="ja-2 " style={{ color: '#3a4b68' }}>
            <strong>Note:</strong> You can select a maximum of 12 subtopics.
          </p>
        </div>



        <div className="did ">


          <p className="ja-2" style={{ marginTop: '18px', fontSize: "14px", fontWeight: '600', color: '#6b778c' }}>
            Total Selected: {state?.subTopics?.length}/{maxSelection} subtopics
          </p>
          {
            isLoading ? <>
              <div>
                <p className='job_size w-100 text-center'> Sub Topics are generating. Please wait <Spinner animation="grow" size='sm' /> </p>
              </div>
              <KeywordSkeleton />
            </> :
              <>
                {/* <h5 className="fw-bold">{subTopic?.topic}</h5> */}
                <div className="row gap-1 " style={{ marginTop: '10px' }}>
                  {console.log(state?.allSubTopics)}
                  {

                    state?.allSubTopics?.map((subTopics, index) => {

                      return <div key={index}>
                        <div style={{ border: '1px solid #eceef1', marginTop: index != 0 ? '8px' : '0px', marginBottom: '16px' }}></div>
                        <h5 style={{ fontSize: '16px', fontWeight: '500', marginTop: index != 0 ? '16px' : '0px' }}>{subTopics?.topic}</h5>
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <label
                              className="jb-4-- form-label-- form-label "
                              style={{ fontSize: "13px", marginTop: '1px' }}
                            >
                              Add Custom Subtopics
                            </label>
                          </div>
                          <div className="d-flex gap-2 mb-2 ">
                            {
                              isLoading ? <InputSkeleton width="30%" /> :

                                <input
                                  name="Custom Broader Topic"
                                  value={newSubTopics[index] || ''}
                                  onChange={(e) => {

                                    let newTopics = [...newSubTopics]

                                    newTopics[index] = e.target.value

                                    console.log(newTopics);

                                    setNewSubTopics(newTopics)

                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      addCutomTopic(index)
                                    }
                                  }}
                                  style={{ width: "30%", height: "37px", }}
                                  className="w-full  rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1"
                                />
                            }
                            <div >
                              <CustomButton
                                title="Add"
                                handleClick={() => {
                                  addCutomTopic(index)
                                }}
                                buttonType='teriory'
                              />
                            </div>
                          </div>


                        </div>
                        <div className="row">

                          {
                            subTopics?.recommended_subtopics?.map((name, Subindex) => {
                              const id = `subtopic-${index}-${Subindex}-rec`;
                              return <div className="col-md-4">
                                <div className="form-check " key={Subindex}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={id}
                                    checked={state.subTopics.includes(name)}
                                    onChange={() => handleChange(name)}
                                    disabled={
                                      state.subTopics.length >= maxSelection &&
                                      !state.subTopics.includes(name)
                                    }
                                  />
                                  <label
                                    style={{ fontSize: "13px" }}
                                    className="form-check-label"
                                    htmlFor={id}
                                  >
                                    {name}
                                  </label>
                                </div>
                              </div>
                            })
                          }
                          {
                            subTopics?.unrecommended_subtopics?.map((subTopic, subindex) => {
                              const id = `subtopic-${index}-${subindex}-unrec`;
                              return <div className="col-md-4" key={subindex}>
                                <div className="form-check " key={subindex}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={id}
                                    checked={state.subTopics.includes(subTopic)}
                                    onChange={() => handleChange(subTopic)}
                                    disabled={
                                      state.subTopics.length >= maxSelection &&
                                      !state.subTopics.includes(subTopic)
                                    }
                                  />
                                  <label
                                    style={{ fontSize: "13px" }}
                                    className="form-check-label"
                                    htmlFor={id}
                                  >
                                    {subTopic}
                                  </label>
                                </div>
                              </div>

                            })
                          }


                        </div>
                      </div>

                    })
                  }
                </div>


              </>



          }

        </div >
        {
          !isLoading && <>

            <div className="question-modal-footer">
              <CustomButton
                title="Back"
                buttonType='secondary'
                handleClick={() => {
                  navigate("/topics")
                }}
              />
              <CustomButton
                title="Proceed"
                handleClick={handleNext}
              />
            </div>
            {/* {sections.map((section, index) => renderSection(section, index))} */}
          </>
        }
      </div>

    </div >
  );
}
